import { createFileRoute } from '@tanstack/react-router'
import CollectionDetailPage from '@/pages/resources/collections/detail'

export const Route = createFileRoute('/app/resources/collections/$id')({
  component: RouteComponent,
})

function RouteComponent() {
  const { id } = Route.useParams()
  return <CollectionDetailPage id={Number(id)} />
}
